import * as htmlToImage from "html-to-image";

const buildDraftEmailPrompt = (projectToken) =>
  `Rédige un email commercial pour le client à partir du projet pricer Episto ${projectToken} ` +
  "(récupère-le avec l'outil get_pricer_project du connecteur Episto : client, brief, cibles, quotas, prix).";

export const openAiHelperView = (projectToken) => {
  window.open(`https://claude.ai/new?q=${encodeURIComponent(buildDraftEmailPrompt(projectToken))}`, "_blank");
};

export const downloadTableAsImage = async (element, projectToken) => {
  if (!element) return;

  try {
    const dataUrl = await htmlToImage.toPng(element, {
      backgroundColor: "#ffffff",
      pixelRatio: 2,
    });

    const link = document.createElement("a");
    link.download = `project-summary-${projectToken || "table"}.png`;
    link.href = dataUrl;
    link.click();
  } catch (err) {
    console.error("Failed to download table image:", err);
  }
};
